import React, { useState } from "react";
import styles from '../Tabs/UserManager.module.scss';
import { addUser } from "../../../../../ApiLayer/admin";

const AddUserForm = ({ onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    if (!formData.email || !formData.password || !formData.confirmPassword) {
      setMessage("Please fill out all fields");
      setIsError(true);
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setMessage("Please enter a valid email address");
      setIsError(true);
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      setMessage("Passwords do not match");
      setIsError(true);
      return false;
    }

    if (formData.password.length < 6) {
      setMessage("Password must be at least 6 characters long");
      setIsError(true);
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset message
    setMessage("");
    setIsError(false);
    
    // Validate form
    if (!validateForm()) {
      return;
    }
    
    // Submit Data
    try {
      setLoading(true);
      const response = await addUser({
        email: formData.email,
        password: formData.password,
      });

      if (!response.success) {
        setMessage(response.message || "Error adding new user");
        setIsError(true);
        return;
      }

      setMessage("User created successfully");
      setIsError(false);

      // Reset form
      setFormData({
        email: "",
        password: "",
        confirmPassword: "",
      });

      // Call onSuccess callback if provided
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      // console.log("Error adding new user: ", err);
      setMessage("Error adding new user");
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.addUserForm}>
      {message && (
        <div className={`${styles.message} ${isError ? styles.error : styles.success}`}>
          {message}
        </div>
      )}
      <div className={styles.inputGroup}>
        <label>New User Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className={styles.inputGroup}>
        <label>New User Password</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
        />
      </div>
      <div className={styles.inputGroup}>
        <label>Confirm Password</label>
        <input
          type="password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
        />
      </div>
      <div className={styles.formButtons}>
        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
        <button type="button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddUserForm;
